import { Injectable } from "@angular/core";
import { CanMatch, Route, Router, UrlSegment, UrlTree } from "@angular/router";
import { GlobalsService } from "../globals.service";

@Injectable({
  providedIn: "root",
})
export class SupplierPortalV2GuardService implements CanMatch {
  public constructor(
    private globalsService: GlobalsService,
    private router: Router,
  ) {}

  public canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    if (this.globalsService.isSupplierPortalV2Enabled()) {
      return true;
    }

    const navigation = this.router.getCurrentNavigation();
    const queryParams = navigation?.initialUrl?.queryParams ?? {};
    const fragment = navigation?.initialUrl?.fragment ?? undefined;

    return this.router.createUrlTree(["/reports-view"], {
      queryParams,
      fragment,
    });
  }
}
